import "./CourseCard.scss";
import { Link } from "react-router-dom";
import { Class } from "../../types";
import { getProductCardImage } from "../../utils/productCardImages";
import ProgressBar from "@ramonak/react-progress-bar";

// `_class` used because `class` is a protected word
const CourseCard = (_class: Class) => {
  // Prefer subjectName, but fall back to className — API subject labels can differ
  // from the displayed class title (which is what users see on the card).
  const bgImage = getProductCardImage(_class.subjectName, _class.className);
  const isActive = _class.isActive !== false;

  const isTrial = _class.isTrial === true;

  const completedPercentage = _class.numberOfQuestions
    ? parseFloat(((_class.numberOfQuestionsCompleted / _class.numberOfQuestions) * 100).toFixed(2))
    : 0;

  const cardContent = (
    <>
      <div
        className="course-bg-image"
        style={bgImage ? { backgroundImage: `url(${bgImage})` } : undefined}
      >
        {isTrial && <span className="course-trial-badge">Free trial</span>}
      </div>
      <div className="course-title-wrapper">
        <span>{_class.className}</span>
        <span id="module-count">
          {_class.modulesCount} module{_class.modulesCount === 1 ? "" : "s"}
        </span>
      </div>

      <div className="progress-bar-wrapper">
        <div className="progress-title-wrapper">
          <span>{isTrial ? "Trial questions used" : "Progress"}</span>
          <span>{_class.numberOfQuestionsCompleted} / {_class.numberOfQuestions} questions ({completedPercentage}%)</span>
        </div>
        <ProgressBar
          completed={completedPercentage}
          bgColor="var(--brand-accent)"
          height="6px"
          isLabelVisible={false}
        />
      </div>
    </>
  );

  if (!isActive && isTrial) {
    return (
      <Link className="course course--trial-ended" to={`/subjects/${_class.subjectId}`}>
        {cardContent}
        <p className="course-expired-label">Trial ended. Review your answers or upgrade</p>
      </Link>
    );
  }

  if (!isActive) {
    return (
      <div className="course course--expired" aria-disabled="true">
        {cardContent}
        <p className="course-expired-label">Access expired</p>
      </div>
    );
  }

  return (
    <Link
      className="course"
      to={`/subjects/${_class.subjectId}`}
    >
      {cardContent}
    </Link>
  );
};

export default CourseCard;
